export default {
      id: "graph-essor02-usage",
      viewBox: "0 0 150 160",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-essor02",
      toString: function () {
        return this.url;
      }
    }